import FlexScrollerComponent from './FlexScroller.vue';
export const FlexScroller = FlexScrollerComponent;
export default FlexScroller;
